import { pathRole } from "./formatter";

export default {
  push: (path, props) => {
    props.history.push(`/${pathRole()}${path}`);
  }
};



// WEBPACK FOOTER //
// ./src/utils/history.js